
/**
 * The internal dependencies.
 */
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export default {
	actions,
	getters,
	mutations,
	state
};



// WEBPACK FOOTER //
// ./src/store/decks/index.js